import styled from "@emotion/styled"
import { FormHelperErrorIcon, FormHelperValidIcon } from "ui"

const StyledContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

type Props = {
  render: boolean
  error: boolean
  text?: string
  completed: string
}

function CustomHelperText({ render, error, text, completed }: Props) {
  // Show error message when there's an error (regardless of touch state)
  // Show success message only when touched and no error
  if (!error && !render) return null

  return (
    <StyledContainer>
      {error ? <FormHelperErrorIcon /> : <FormHelperValidIcon />}
      <p
        style={{
          margin: 0,
          textAlign: "right",
          width: "120%",
          color: error ? "#C92418" : "#008015",
          marginRight: "4px",
        }}
      >
        {error ? text : completed}
      </p>
    </StyledContainer>
  )
}

export default CustomHelperText
